(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('insurancerequestApp')
        .constant('CONST_INSURANCE_REQUEST', {
        	'TVV' : '0',
        	'AD' : '1',
        	'REASON_TVV': "Nhận cho TVV",
        	'REASON_GP' : "Nhận cho GP/Other event",
        	'URL_MENU':"menu/#/menu",
        	'URL_INSURANCE_REQUEST' : "insurancerequest/#/insurancerequest"
        });
})();
